import { render, staticRenderFns } from "./Institutions.html?vue&type=template&id=14be0ea8&external"
import script from "./Institutions.js?vue&type=script&lang=js&external"
export * from "./Institutions.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports